module.exports = __webpack_public_path__ + "_/img/FiveGuysLocation.9e6f47c8.svg";